/**
 * Single source of truth for Mae's identity: a home search agent.
 *
 * To rename the advisor, edit ADVISOR_NAME and ADVISOR_AVATAR_INITIAL here.
 * Keep backend/internal advisor naming for compatibility; buyer-facing UI
 * should use Mae as the persistent person across the product.
 */

export const ADVISOR_NAME = "Mae";
export const ADVISOR_AVATAR_INITIAL = "M";
export const ADVISOR_TAGLINE = "Your home search agent";
export const ADVISOR_PRODUCT_LABEL = "home search agent";

/**
 * Full byline shown in chat avatars and message headers.
 * Example: "Mae · Your home search agent"
 */
export const ADVISOR_BYLINE = `${ADVISOR_NAME} · ${ADVISOR_TAGLINE}`;
